import {useLocation} from 'react-router'
import {ideationApi} from '../../../../../../api/ideationApi'
import styles from './IdeationEmotions.module.scss'

import satisfactionLogo from '../../../../../../assets/Images3/satisfaction.png'
import frustrationLogo from '../../../../../../assets/Images3/frustration.png'
import appreciationLogo from '../../../../../../assets/Images3/appreciation.png'
import disengagementLogo from '../../../../../../assets/Images3/disengagement.png'
import stressLogo from '../../../../../../assets/Images3/stress.png'
import hopefulnessLogo from '../../../../../../assets/Images3/hopefulness.png'
import resentmentLogo from '../../../../../../assets/Images3/resentment.png'
import inspiredLogo from '../../../../../../assets/Images3/inspired.png'
import afraidLogo from '../../../../../../assets/Images3/afraid.png'
import excitementLogo from '../../../../../../assets/Images3/excitement.png'

const emotionImages: Record<string, string> = {
  Satisfaction: satisfactionLogo,
  Frustration: frustrationLogo,
  Appreciation: appreciationLogo,
  Disengagement: disengagementLogo,
  Stress: stressLogo,
  Hopefulness: hopefulnessLogo,
  Resentment: resentmentLogo,
  Inspired: inspiredLogo,
  Afraid: afraidLogo,
  Excitement: excitementLogo,
}

export const IdeationEmotions: React.FC = () => {
  const {search} = useLocation()
  const ideationId = search ? search.substring(1) : ''
  const {data: insights} = ideationApi.useIdeationInsights(ideationId)
  const emotions = (insights?.top_emotions ?? []).slice(0, 3)

  return (
    <div className={styles.ideationEmotions}>
      <div className="ideation-section-title">{'Top Emotions'}</div>
      <div className={styles.ideationEmotionsDiv}>
        {emotions.map((elt, index) => (
          <div className={styles.ideationEmotionsLogoDiv} key={index}>
            <img
              className={styles.ideationEmotionsLogo}
              src={emotionImages[elt.emotion]}
              alt={'logo'}
            />
            <div className={styles.ideationEmotionsText}>{elt.emotion}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
